import { render, staticRenderFns } from "./InterviewRoom.vue?vue&type=template&id=d881d20e"
import script from "./InterviewRoom.vue?vue&type=script&lang=js"
export * from "./InterviewRoom.vue?vue&type=script&lang=js"
import style0 from "./InterviewRoom.vue?vue&type=style&index=0&id=d881d20e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports